export enum FeedbackIssues {
    INACCURATE = 1,
    UNCLEAR,
    TOO_LONG,
    LACK_OF_IMPORTANT_INFO,
    OTHER
}

export const FeedbackIssuesValues = [
    { id: FeedbackIssues.INACCURATE, name: 'Inaccurate' },
    { id: FeedbackIssues.UNCLEAR, name: 'Unclear' },
    { id: FeedbackIssues.TOO_LONG, name: 'Too long' },
    { id: FeedbackIssues.LACK_OF_IMPORTANT_INFO, name: 'Lack of important info' },
    { id: FeedbackIssues.OTHER, name: 'Other' }
];
